import { useEffect, useState } from "react";
import Lenis from "lenis";
import { MessageCircle } from "lucide-react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DEALERSHIP } from "@/data/site";
import Admin from "@/components/Admin";
import OfferBanner from "@/components/OfferBanner";
import GoogleRating from "@/components/GoogleRating";
import MissedCall from "@/components/MissedCall";
import Gallery from "@/components/Gallery";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Lineup from "@/components/Lineup";
import Manifesto from "@/components/Manifesto";
import EmiCalculator from "@/components/EmiCalculator";
import TestDrive from "@/components/TestDrive";
import ServiceBooking from "@/components/ServiceBooking";
import Locations from "@/components/Locations";
import Footer from "@/components/Footer";

function Landing() {
  const [selectedModel, setSelectedModel] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#05141F] min-h-screen">
      <Toaster position="top-center" richColors toastOptions={{ style: { borderRadius: 0 } }} />
      <Navbar />
      <main>
        <OfferBanner />
        <Hero />
        <Marquee />
        <Lineup onBookModel={setSelectedModel} />
        <Manifesto />
        <Gallery />
        <EmiCalculator />
        <TestDrive selectedModel={selectedModel} />
        <ServiceBooking />
        <MissedCall />
        <Locations />
        <GoogleRating />
      </main>
      <Footer />
      <a
        data-testid="whatsapp-chat-button"
        href={`https://wa.me/${DEALERSHIP.whatsapp}?text=${encodeURIComponent("Hi Sanjib Kia! I'm interested in a Kia vehicle and would like to know more.")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 grid place-items-center bg-white text-black rounded-full shadow-lg shadow-white/20 hover:scale-110 transition-transform duration-300"
        aria-label="Chat with Sanjib Kia on WhatsApp"
      >
        <MessageCircle size={26} />
      </a>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export { App as default };
